import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import { Text } from "components";
import AlertDialog from "components/Dialog/index";
import Spinner from "components/spinner";
import React from "react";
import { toastr } from "react-redux-toastr";
import CreateArea from "../../accountsDrawer/CreateNot";
import NotesCom from "../../accountsDrawer/Notes";
import "../style.scss";
const Notes = ({ accountId }) => {
  const [notes, setNotes] = React.useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [refresh, setRefresh] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [editNote, setEditNote] = React.useState(false);
  const [noteToEdit, setNoteToEdit] = React.useState("");
  const [openConfirmDelete, setOpenConfirmDelete] = React.useState({
    open: false,
    id: null,
    loading: false,
  });

  React.useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      AuthService.getNotesByAccountId(accountId, token)
        .then((res) => {
          setNotes(Array.isArray(res) ? res : []);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }, [refresh]);
  const handleAddNote = async (note, tags = []) => {
    const token = await getAccessTokenSilently();
    const data = {
      account_id: accountId,
      note: note,
      tags,
    };
    AuthService.createNote(data, token)
      .then((res) => {
        if (res) {
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const onDeleteClick = (id) => {
    setOpenConfirmDelete(prevState => ({
      ...prevState,
      open: true,
      id: id,
    }));
  }

  const closeConfirmDelete = () => {
    setOpenConfirmDelete(prevState => ({
      ...prevState,
      open: false,
      id: null,
      loading: false,
    }));
  }


  const handleDeleteNote = async () => {
    setOpenConfirmDelete(prevState => ({
      ...prevState,
      loading: true,
    }));
    const token = await getAccessTokenSilently();
    await AuthService.removeNote(
      {
        noteIds: [`${openConfirmDelete.id}`],
      },
      token
    )
      .then((res) => {
        if (res) {
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      })
      .finally(() => {
        setOpenConfirmDelete(prevState => ({
          ...prevState,
          open: false,
          id: null,
          loading: false,
        }));
      });
  };

  const handleEditNote = async (note) => {
    setEditNote(true);
    setNoteToEdit(note);
  }

  return (
    <>
      <div className="row">
        <div className="new-note col-sm-5">
          <div className="family-table-container p-15">
            <div className="my-auto page-header p-0">
              <Text className="sub-title pb-6">New Note</Text>
            </div>
            <CreateArea 
              rows={10} 
              handleAdd={handleAddNote} 
              noteToEdit={noteToEdit}
              setNoteToEdit={setNoteToEdit}
              editNote={editNote}
              setEditNote={setEditNote}
              refresh={refresh}
              setRefresh={setRefresh}
              setLoading={setLoading}
              accountId={accountId}
            />
          </div>
        </div>
        <div className="note-list col-sm-7">
          <div className="family-table-container p-15">
            <div className="my-auto page-header p-0">
              <Text className="sub-title pb-6">
                Notes{notes.length ? ` (${notes.length})` : ""}
              </Text>
            </div>
            {loading && <Spinner/>}
            <NotesCom
              details={true}
              notes={notes}
              handleDelete={onDeleteClick}
              handleEditNote={handleEditNote}
            />
          </div>
        </div>
      </div>
      <AlertDialog
        open={openConfirmDelete.open}
        onDecline={closeConfirmDelete}
        onAccept={handleDeleteNote}
        title={`Are you sure?`}
        description={"Do you want to delete this note?"}
        disabled={openConfirmDelete.loading}
      />
    </>
  );
};

export default Notes;
